module.exports = __webpack_public_path__ + "img/Illustration (1).0cea701e.png";